'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _types = require('./types');

var initialState = {
  message: null,
  open: false,
  action: null
};

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case _types.SHOW:
      var message = payload.message,
          action = payload.action,
          handleAction = payload.handleAction;

      return _extends({}, state, { open: true, message: message || payload, action: action, handleAction: handleAction });
    case _types.DISMISS:
      return _extends({}, state, { open: false, action: null, handleAction: null });
    default:
      return state;
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/material-ui-snackbar-redux/lib/reducer.js
// module id = 665
// module chunks = 0